// extracted by mini-css-extract-plugin
export var avatar = "_nk-3";
export var avatarContainer = "_nk-2";
export var avatarSpacer = "_nk-5";
export var avatarSpacerContainer = "_nk-4";
export var avatarStackContainer = "_nk-1";
export var bubble = "_nk-0";
export var remainderBubble = "_nk-6";